import React from "react";

export function Error404() {
    return (
        <div style={{ display: "flex", padding: "5%", justifyContent: "center", alignItems: "center", fontSize: "100px", gridArea: "c" }}>404</div>
    )
}